__turbopack_context__.v({
  "right": "trustedBadge-module-scss-module__qbKN2G__right",
  "trustedBadge": "trustedBadge-module-scss-module__qbKN2G__trustedBadge",
});
